import { EcardLandingLeftPane } from './EcardLandingLeftPane';
export default EcardLandingLeftPane;
